import { render, staticRenderFns } from "./trainingMaterials.vue?vue&type=template&id=98063c9a&scoped=true"
import script from "./trainingMaterials.vue?vue&type=script&lang=js"
export * from "./trainingMaterials.vue?vue&type=script&lang=js"
import style0 from "./trainingMaterials.vue?vue&type=style&index=0&id=98063c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98063c9a",
  null
  
)

export default component.exports